import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Send } from "lucide-react";
import PublicLayout, { PageHero } from "../../components/PublicLayout";
import { useLang } from "../../context/LanguageContext";
import { Spinner } from "../../components/ui-kit";
import api from "../../lib/api";

const Contact = () => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/contact", form);
      if (data.ok) {
        setForm({ name: "", email: "", subject: "", message: "" });
        toast.success(t("pages.contact.success"));
      } else {
        toast.error(t("pages.contact.error"));
      }
    } catch (err) {
      toast.error(t("pages.contact.error"));
    } finally {
      setBusy(false);
    }
  };
  const input = "w-full h-12 px-4 rounded-lg bg-[#181818] border border-[#2A2A2A] text-white text-[16px] placeholder-neutral-600 focus:outline-none focus:border-[#FF5C00] transition-colors";
  return (
    <PublicLayout>
      <PageHero eyebrow={t("pages.contact.eyebrow")} title={t("pages.contact.title")} subtitle={t("pages.contact.subtitle")} />
      <section className="max-w-[900px] mx-auto px-6 pb-24 grid grid-cols-1 md:grid-cols-[300px_1fr] gap-10">
        <div className="space-y-4">
          <div className="flex items-start gap-3"><div className="w-10 h-10 rounded-xl bg-[#FF5C00]/12 flex items-center justify-center shrink-0"><Mail size={18} className="text-[#FF5C00]" /></div><div><div className="text-white font-medium">{t("pages.contact.email")}</div><div className="text-[14px] text-neutral-500">hello@talentsio.com</div></div></div>
          <div className="flex items-start gap-3"><div className="w-10 h-10 rounded-xl bg-[#FF5C00]/12 flex items-center justify-center shrink-0"><MapPin size={18} className="text-[#FF5C00]" /></div><div><div className="text-white font-medium">{t("pages.contact.office")}</div><div className="text-[14px] text-neutral-500">Sweden</div></div></div>
        </div>
        <form onSubmit={submit} className="space-y-3" data-testid="contact-form">
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="contact-name-input" className={input} placeholder={t("pages.contact.name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            <input data-testid="contact-email-input" className={input} type="email" placeholder={t("pages.contact.emailField")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </div>
          <input data-testid="contact-subject-input" className={input} placeholder={t("pages.contact.subject")} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required />
          <textarea data-testid="contact-message-input" className={`${input} h-36 py-3`} placeholder={t("pages.contact.message")} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
          <button data-testid="contact-submit-btn" disabled={busy} className="flex items-center gap-2 bg-[#1A8A4A] hover:bg-[#20A458] text-white font-semibold px-6 py-3 rounded-xl transition-colors disabled:opacity-100 disabled:bg-[#3a3a3a] disabled:text-neutral-500 disabled:cursor-not-allowed disabled:bg-[#3a3a3a] disabled:text-neutral-500 disabled:cursor-not-allowed">{busy ? <Spinner className="w-4 h-4" /> : <><Send size={16} /> {t("pages.contact.send")}</>}</button>
        </form>
      </section>
    </PublicLayout>
  );
};

export default Contact;
